<template>
  <router-view v-slot="{ Component }">
    <keep-alive :include="includeList">
      <component :is="Component" />
    </keep-alive>
  </router-view>
  <div class="menu_wkBox_back_box" />
</template>

<script lang="ts" setup>
import { ref, watch, Ref } from 'vue'
import { useRoute, RouteRecordName } from 'vue-router'

const includeList: Ref<string[]> = ref([])
const route = useRoute()

watch(
  () => route,
  newValue => {
    const name = newValue.name as RouteRecordName as string
    if (
      newValue.meta.childKeepAlive &&
      includeList.value.indexOf(name) === -1
    ) {
      includeList.value.push(name)
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="scss" scoped>
.content-layout {
  min-height: 100vh;
}
</style>
